import { CMService } from '../services'

const getDefaultState = () => {
    return {
        dataset: [],
        fetching: false,
        page: 0,
        limit: 25,
        lastCountResult: 0,
        view: ""
    }
}



const state = {...getDefaultState(), filters: [], selected: [] }

const actions = {
    cleanState({ commit }) {
        commit('resetState')
        commit('resetSessionState')
    },
    resetState ({ commit }) {
        commit('resetState')
    },
    fetchReport ({ commit, state }) {
        commit('setFetching', true)
        commit('setView', 'g')
        CMService.saleOpenPickingListGeneral(state.filters, '', state.page, state.limit)
            .then(({ data }) => {
                commit('addReport', data)
                commit('incrementPage')
            })
            .finally(() => commit('setFetching', false))
    },
    fetchReportByInvoice({ commit }, order_number) {
        commit('setFetching', true)
        commit('setView', 'i')
        CMService.saleOpenPickingList(order_number)
            .then(({ data }) => {
                commit('addReport', data)
                commit('incrementPage')
            })
            .finally(() => commit('setFetching', false))
    },
    export({ commit }, order_number) {
        commit('setFetching', true)

        CMService.saleOpenPickingList(order_number, 'xls')
        .finally(() => commit('setFetching', false))
    },
    exportGeneral({ commit, state }) {
        commit('setFetching', true)

        CMService.saleOpenPickingListGeneral(state.filters,'xls')
        .finally(() => commit('setFetching', false))
    },
    updateFilters({ commit }, row) {
        commit('updateFilters', row)
    },
    updateSelection({commit}, values) {
        commit('updateSelection', values)
    },
    clearSelection({commit}) {
        commit('clearSelection')
    },
    clearData({ commit }) {
        commit('resetState')
        
    }
}

const mutations = {
    resetSessionState: (state) => {state.filters=[]; state.selected=[]},
    resetState: (state) => (Object.assign(state, getDefaultState())),
    updateFilters: (state, filters) => (state.filters = filters),
    addReport: (state, data) => { state.dataset.push(...data); state.lastCountResult = data.length},
    updateSelection: (state, values) => (state.selected = values),
    clearSelection: (state) => (state.selected = []),
    incrementPage: (state) => (state.page++),
    setFetching: (state, payload) => (state.fetching = payload),
    setView: (state, view) => (state.view = view)
}


export const cmPickingList = {
    namespaced: true,
    state,
    mutations,
    actions,
};


// WEBPACK FOOTER //
// ./src/store/cmPickingList.js